"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baiduMap = require("@/utils/baiduMap");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var DEFAULT_CENTER = {
  lng: 104.065735,
  lat: 30.659462
};
var _default2 = exports.default = {
  name: 'StoreAddressPicker',
  props: {
    region: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    storeAddress: {
      type: String,
      default: ''
    },
    longitude: {
      type: [String, Number],
      default: ''
    },
    latitude: {
      type: [String, Number],
      default: ''
    },
    areaOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      provinceId: null,
      cityId: null,
      districtId: null,
      localAddress: this.storeAddress,
      map: null,
      marker: null,
      geocoder: null,
      mapReady: false,
      syncingRegion: false,
      mapContainerId: "store-baidu-map-".concat(this._uid)
    };
  },
  computed: {
    provinceList: function provinceList() {
      return this.areaOptions || [];
    },
    cityList: function cityList() {
      var _this = this;
      var province = this.provinceList.find(function (item) {
        return item.id === _this.provinceId;
      });
      return province && province.child || [];
    },
    districtList: function districtList() {
      var _this2 = this;
      var city = this.cityList.find(function (item) {
        return item.id === _this2.cityId;
      });
      return city && city.child || [];
    },
    searchBtnDisabled: function searchBtnDisabled() {
      return this.disabled || !this.provinceId || !this.cityId || !this.districtId;
    }
  },
  watch: {
    active: function active(val) {
      if (val) {
        this.scheduleInitMap();
      } else {
        this.destroyMap();
      }
    },
    region: {
      immediate: true,
      handler: function handler(val) {
        this.syncRegionFromProp(val);
      }
    },
    storeAddress: function storeAddress(val) {
      if (val !== this.localAddress) {
        this.localAddress = val || '';
      }
    },
    areaOptions: function areaOptions() {
      this.syncRegionFromProp(this.region);
    },
    longitude: function longitude(val) {
      if (this.mapReady && val && this.latitude && !this.marker) {
        this.setMapPosition(parseFloat(val), parseFloat(this.latitude));
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyMap();
  },
  methods: {
    scheduleInitMap: function scheduleInitMap() {
      var _this3 = this;
      var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$nextTick(function () {
        setTimeout(function () {
          _this3.initMap(retry);
        }, retry === 0 ? 300 : 200);
      });
    },
    syncRegionFromProp: function syncRegionFromProp(region) {
      var _this4 = this;
      if (!Array.isArray(region)) return;
      this.syncingRegion = true;
      this.provinceId = region[0] || null;
      this.cityId = region[1] || null;
      this.districtId = region[2] || null;
      this.$nextTick(function () {
        _this4.syncingRegion = false;
      });
    },
    emitRegion: function emitRegion() {
      var region = [this.provinceId, this.cityId, this.districtId].filter(function (id) {
        return id;
      });
      this.$emit('update:region', region);
    },
    handleProvinceChange: function handleProvinceChange() {
      this.cityId = null;
      this.districtId = null;
      this.emitRegion();
    },
    handleCityChange: function handleCityChange() {
      this.districtId = null;
      this.emitRegion();
    },
    handleDistrictChange: function handleDistrictChange() {
      var _this5 = this;
      this.emitRegion();
      this.$nextTick(function () {
        return _this5.triggerFormValidate();
      });
    },
    handleAddressInput: function handleAddressInput(val) {
      this.$emit('update:storeAddress', val);
    },
    getSelectedRegionText: function getSelectedRegionText() {
      var _this6 = this;
      var province = this.provinceList.find(function (item) {
        return item.id === _this6.provinceId;
      });
      var city = this.cityList.find(function (item) {
        return item.id === _this6.cityId;
      });
      var district = this.districtList.find(function (item) {
        return item.id === _this6.districtId;
      });
      return [province && province.name, city && city.name, district && district.name].filter(Boolean).join('');
    },
    searchAddress: function searchAddress() {
      var _this7 = this;
      if (!this.provinceId || !this.cityId || !this.districtId) {
        this.$message.warning('请先选择省市区');
        return;
      }
      if (!this.localAddress || !this.localAddress.trim()) {
        this.$message.warning('请填写门店具体位置');
        return;
      }
      if (!this.mapReady || !this.geocoder) {
        this.$message.warning('地图尚未加载完成，请稍后再试');
        return;
      }
      var cityName = this.cityList.find(function (item) {
        return item.id === _this7.cityId;
      });
      var city = cityName && cityName.name || '';
      var fullAddress = this.getSelectedRegionText() + this.localAddress.trim();
      this.geocoder.getPoint(fullAddress, function (point) {
        if (point) {
          _this7.setMapPosition(point.lng, point.lat);
          _this7.$emit('update:longitude', String(point.lng));
          _this7.$emit('update:latitude', String(point.lat));
          _this7.$nextTick(function () {
            return _this7.triggerFormValidate();
          });
        } else {
          _this7.$message.error('未找到该地址，请检查省市区和详细地址是否正确');
        }
      }, city);
    },
    initMap: function () {
      var _initMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this8 = this;
        var retry,
          container,
          BMap,
          hasCoords,
          centerPoint,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              retry = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
              if (this.active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return (0, _baiduMap.loadBaiduMap)();
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('[StoreAddressPicker] 百度地图加载失败:', _t);
              this.$message.error(_t.message || '百度地图加载失败');
              return _context.a(2);
            case 4:
              container = document.getElementById(this.mapContainerId);
              if (container) {
                _context.n = 5;
                break;
              }
              if (retry < 5) this.scheduleInitMap(retry + 1);
              return _context.a(2);
            case 5:
              if (!(container.offsetWidth === 0 || container.offsetHeight === 0)) {
                _context.n = 6;
                break;
              }
              if (retry < 8) this.scheduleInitMap(retry + 1);
              return _context.a(2);
            case 6:
              if (!this.map) {
                _context.n = 7;
                break;
              }
              this.map.checkResize();
              return _context.a(2);
            case 7:
              BMap = window.BMap;
              this.map = new BMap.Map(this.mapContainerId);
              this.geocoder = new BMap.Geocoder();
              hasCoords = this.longitude && this.latitude;
              centerPoint = hasCoords ? new BMap.Point(parseFloat(this.longitude), parseFloat(this.latitude)) : new BMap.Point(DEFAULT_CENTER.lng, DEFAULT_CENTER.lat);
              this.map.centerAndZoom(centerPoint, hasCoords ? 16 : 12);
              this.map.enableScrollWheelZoom(true);
              this.map.addControl(new BMap.NavigationControl());
              this.map.addControl(new BMap.ScaleControl());
              if (hasCoords) {
                this.setMarker(centerPoint);
              }
              this.map.addEventListener('click', function (e) {
                if (_this8.disabled) return;
                _this8.handleMapClick(e.point);
              });
              this.mapReady = true;
              setTimeout(function () {
                if (_this8.map) _this8.map.checkResize();
              }, 200);
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function initMap() {
        return _initMap.apply(this, arguments);
      }
      return initMap;
    }(),
    handleMapClick: function handleMapClick(point) {
      var _this9 = this;
      this.setMapPosition(point.lng, point.lat);
      this.$emit('update:longitude', String(point.lng));
      this.$emit('update:latitude', String(point.lat));
      this.geocoder.getLocation(point, function (result) {
        if (!result) {
          _this9.$message.warning('无法解析该位置的地址信息');
          return;
        }
        var comp = result.addressComponents;
        _this9.applyRegionByName(comp.province, comp.city, comp.district);
        var detailAddress = _this9.extractDetailAddress(comp, result.address);
        _this9.localAddress = detailAddress;
        _this9.$emit('update:storeAddress', detailAddress);
        _this9.$nextTick(function () {
          return _this9.triggerFormValidate();
        });
      });
    },
    applyRegionByName: function applyRegionByName(provinceName, cityName, districtName) {
      var _this0 = this;
      var province = this.findAreaByName(this.provinceList, provinceName);
      if (!province) return;
      this.syncingRegion = true;
      this.provinceId = province.id;
      var cities = province.child || [];
      var city = this.findAreaByName(cities, cityName, provinceName);
      this.cityId = city ? city.id : null;
      var districts = city && city.child || [];
      var district = this.findAreaByName(districts, districtName, cityName);
      this.districtId = district ? district.id : null;
      this.$nextTick(function () {
        _this0.syncingRegion = false;
        _this0.emitRegion();
      });
    },
    findAreaByName: function findAreaByName(list, name, parentName) {
      var _this1 = this;
      if (!list || !list.length || !name) return null;
      var normalizedTarget = this.normalizeAreaName(name);
      var matched = list.find(function (item) {
        return _this1.normalizeAreaName(item.name) === normalizedTarget;
      });
      if (matched) return matched;
      matched = list.find(function (item) {
        return item.name === name || name.includes(item.name) || item.name.includes(name);
      });
      if (matched) return matched;
      if (parentName) {
        var parentNorm = this.normalizeAreaName(parentName);
        if (normalizedTarget === parentNorm) return list[0];
      }
      return null;
    },
    normalizeAreaName: function normalizeAreaName(name) {
      if (!name) return '';
      return name.replace(/(特别行政区|自治区|自治州|地区|盟|省|市|区|县)$/g, '').replace(/壮族|回族|维吾尔/g, '').trim();
    },
    extractDetailAddress: function extractDetailAddress(comp, fullAddress) {
      var streetPart = [comp.street, comp.streetNumber].filter(Boolean).join('');
      if (streetPart) return streetPart;
      var detail = fullAddress || '';
      [comp.province, comp.city, comp.district].forEach(function (part) {
        if (part && detail.indexOf(part) === 0) {
          detail = detail.slice(part.length);
        }
      });
      return detail.trim();
    },
    triggerFormValidate: function triggerFormValidate() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$refs && parent.$refs.storeForm) {
          parent.$refs.storeForm.validateField(['region', 'storeAddress', 'longitude']);
          break;
        }
        parent = parent.$parent;
      }
    },
    setMapPosition: function setMapPosition(lng, lat) {
      var point = new window.BMap.Point(lng, lat);
      this.map.panTo(point);
      this.setMarker(point);
    },
    setMarker: function setMarker(point) {
      if (this.marker) {
        this.map.removeOverlay(this.marker);
      }
      this.marker = new window.BMap.Marker(point);
      this.map.addOverlay(this.marker);
    },
    destroyMap: function destroyMap() {
      if (this.map) {
        this.map.clearOverlays();
        this.map = null;
      }
      this.marker = null;
      this.geocoder = null;
      this.mapReady = false;
    },
    refreshMap: function refreshMap() {
      if (!this.active) return;
      if (this.map) {
        this.map.checkResize();
        return;
      }
      this.scheduleInitMap();
    }
  }
};